import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const About = () => {
  const { ref, isVisible } = useScrollAnimation()

  const aboutCards = [
    {
      icon: 'fas fa-map-location-dot',
      title: 'True Kiwi Expertise',
      description: 'Built by Kiwis, we understand the New Zealand job market inside out—its industries, regions, and what employers and candidates genuinely value.'
    },
    {
      icon: 'fas fa-people-group',
      title: 'The Right Fit, Not Just Any Fit',
      description: 'We go beyond skills and experience. TalentHouse focuses on matching the right people to the right environments, ensuring a strong cultural fit that leads to long-term success for both businesses and candidates.'
    },
    {
      icon: 'fas fa-scale-balanced',
      title: 'Trusted & Compliant',
      description: 'With solid knowledge of New Zealand employment laws, including the Employment Relations Act 2000, we ensure every placement is handled professionally, fairly, and with full compliance.'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Personalised, People-First Approach',
      description: 'We take the time to understand your goals—whether you\'re hiring or job hunting. Our tailored approach means better matches, smoother processes, and outcomes you can trust.'
    }
  ]

  return (
    <section id="about" className="about section" ref={ref}>
      <div className="container">
        <div className="section-header">
          <div className={`section-tag ${isVisible ? 'animate-fadeInUp' : ''}`}>
            About Us
          </div>
          <h2 className={`${isVisible ? 'animate-fadeInUp' : ''}`}>
            Why Choose <span className="gradient-text">TalentHouse</span>?
          </h2>
          <p className={`section-subtext ${isVisible ? 'animate-fadeInUp' : ''}`}>
            Built by Kiwis, we understand the New Zealand job market inside out, its industries, regions, and what employers and candidates genuinely value.
          </p>
        </div>

        <div className="about-grid">
          {aboutCards.map((card, index) => (
            <div 
              key={index} 
              className={`about-card card card-accent-top ${isVisible ? 'animate-fadeInUp' : ''}`}
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="card-header">
                <div className="about-icon">
                  <i className={card.icon}></i>
                </div>
                <h3>{card.title}</h3>
              </div>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default About
